/**
 * The real Pickup Hungary logo — the files the public site ships, copied into
 * this app's public/ folder (ph-logo.svg, ph-logo-white.svg).
 *
 *   variant="color"  single-line lockup, dark wordmark, for light surfaces
 *   variant="white"  stacked lockup (mark over PICKUP / HUNGARY), for the
 *                    dark screens: enrolment, the gate, the name sign
 *
 * One component so the brand is set in one place, not re-drawn per screen.
 */
import React from 'react';

const SOURCES = {
  color: 'ph-logo.svg',
  white: 'ph-logo-white.svg',
};

export default function BrandLogo({ variant = 'color', height = 22, className = '' }) {
  const file = SOURCES[variant] || SOURCES.color;
  return (
    <img
      src={`${process.env.PUBLIC_URL || ''}/${file}`}
      alt="Pickup Hungary"
      height={height}
      className={['pp-logo', className].filter(Boolean).join(' ')}
    />
  );
}
